 <template>
  <div>
    <el-dialog
      title="APP下载"
      :visible.sync="centerDialogVisible"
      width="770px"
      center
    >
      <img src="@/assets/images/down.png">

    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  methods: {
    click() {
      this.centerDialogVisible = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/fixed/download.vue